(function () {
  'use strict';

  /* @ngdoc object
   * @name crewStandByReport
   * @description
   *
   */
  angular
    .module('crewStandByReport', [
      'ui.router'
    ]);
}());
